module.exports = __webpack_public_path__ + "static/media/exc_sit_spe_met.300af2b7.png";